/**
 * useReturnedSchedules.js
 *
 * Hook to load TransactionSchedule rows that have at least one
 * RETURNED_PARTIAL or RETURNED_FULL allocation check status.
 *
 * Place this file in: src/hooks/useReturnedSchedules.js
 */

import { useCallback, useState } from "react";
import { message } from "antd";
import { getReturnedSchedules } from "../api/transactionScheduleApi";

export default function useReturnedSchedules() {
    const [returnedSchedules, setReturnedSchedules] = useState([]);
    const [loadingReturnedSchedules, setLoadingReturnedSchedules] = useState(false);

    const loadReturnedSchedules = useCallback(async () => {
        setLoadingReturnedSchedules(true);
        try {
            const data = await getReturnedSchedules();
            setReturnedSchedules(data || []);
            return data || [];
        } catch (error) {
            message.error(error.message || "Буцаалттай хуваариудыг ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingReturnedSchedules(false);
        }
    }, []);

    return {
        returnedSchedules,
        loadingReturnedSchedules,
        loadReturnedSchedules,
    };
}